import { render, staticRenderFns } from "./enable_review_app_modal.vue?vue&type=template&id=2042c13a"
import script from "./enable_review_app_modal.vue?vue&type=script&lang=js"
export * from "./enable_review_app_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports